import React, { useEffect, useState } from "react";
import { Table, Button, IconPlus, Search, Select } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Col, Row } from "react-bootstrap";
import LowCoverageUpload from "./LowCoverageUpload";

const FrameCoverageRender = ( props ) => {
    //Variables
    const [t] = useTranslation();
    const connectApi = new ConnectAPI();
    const [loadingData, setLoadingData] = useState(false);
    const [dateSelected, setDateSelected] = useState();
    const [datalow,setdatalow]=useState([]);
    const [lowdate, setlowdate]=useState();
    const [selectlow, setselectlow]=useState([]);

    //Metodos
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    }
    const fetchData = async () => {
        setDateSelected('');
        setlowdate('');
        setselectlow([]);
        setdatalow([]);

        connectApi.get(
            "api/Channels/AllTables",
            { params: { viewRequired: 'frame_coverage' } },
            dataResponseLoad
        ).catch((error) => {
            setLoadingData(false);
            Swal.fire(
                "Error " + error.response,
                error.response,
                "error"
            );
        });
        setLoadingData(true);
    };
    const dataResponseLoad = (status, data) => {
        data['dataListCoverageFrame'].forEach(x => {
            x.monthyear = moment(x.monthyear).format("MMM/DD/YYYY");
        });
        setDateSelected( moment(data['date']).format("MM-DD-YYYY") );
        var datescoverage=sort(data['dataListCoverageFrame'], "descending", "monthyear").map(item=>item.monthyear).filter(onlyUnique);
        let datesformat=datescoverage.map((item,key)=>{
            return{
                value: moment(item).format("DD/MMM/YYYY"),
                label: item,
            };
        });
        setlowdate(datesformat[datesformat.length-1].value);
        setselectlow(datesformat);
        setdatalow(data['dataListCoverageFrame']);
        setLoadingData(false)
    };
    useEffect(() => {
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        fetchData();
    }, []);

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if (  orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } if( orderBy === "channel" || orderBy === "name" 
            || orderBy === "createdBy" || orderBy === "classification" 
            || orderBy === "description" || orderBy==="namecustomer" || orderBy==="nameEndUser" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        } else if( orderBy === "startDate" || orderBy === "endDate"
                || orderBy === "date" || orderBy === "monthYear" ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseFloat(bSort) < parseFloat(aSort)) 
                return -1;
            if (parseFloat(bSort) > parseFloat(aSort))
                return 1;
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                    const aUpper = a[value] && a[value].toString().toUpperCase();
                    const filterUpper = filter && filter.toString().toUpperCase();
                    return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    function sort(array, orderBy, orderType) { 
        return array.sort((a, b) => {
          const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy)
            : -descendingComparator(a, b, orderBy);
      
          return value;
        });
    }

    //Vista
    const TableCoverage=()=>{
        const [idpressFilterValue, setidpressFilterValue]=useState("");
        const [customerFilterValue, setcustomerFilterValue]=useState("");
        const [currentPage, setCurrentPage] = useState(1);
        const [enduserFilterValue, setenduserFilterValue]=useState("");
        const handlePageChange = (page) => setCurrentPage(page);
        const [pageSize, setPageSize] = useState(15);
        const columns = [
            {
                id:'customerName',
                label:"Name Customer",
                filter: (
                    <Search
                        id="customer-search"
                        value={customerFilterValue}
                        onChange={setcustomerFilterValue}
                    />
                )
            },
            {
                id:'endUserName',
                label:'Name End User',
                filter: (
                    <Search
                        id="enduser-search"
                        value={enduserFilterValue}
                        onChange={setenduserFilterValue}
                    />
                )
            },
            {
                id: 'idpres',
                label: 'Press',
                filter: (
                    <Search
                        id="idpress-search"
                        value={idpressFilterValue}
                        onChange={setidpressFilterValue}
                    />
                )
            },
            {
                id: 'monthyear',
                label: 'MonthYear',
            },
            {
                id: 'printedImps',
                label: 'Printed Imps',
            },
            {
                id: 'percentageCoverage',
                label: 'Percantage Coverage',
            },
            {
                id:'frameWidth',
                label:'Frame Width',
            }
        ];
        const [orderBy, setOrderBy] = useState('namecustomer');
        const [orderType, setOrderType] = useState('ascending');
        const [order, setOrder] = useState(columns.map((c) => c.id));
        let slicedata=[];
        let filteredData=[];
        if (datalow.length>0){
            filteredData = filterSort(
                datalow, {
                    monthyear: moment(lowdate).format("MMM/DD/YYYY"),
                    endUserName:enduserFilterValue,
                    customerName:customerFilterValue,
                    idpres:idpressFilterValue

                },
                orderBy,
                orderType
            );
            slicedata=filteredData.slice(
                (currentPage - 1) * pageSize,
                (currentPage - 1) * pageSize + pageSize
            );
        }
        
        const handleOnColumnReorder = (newOrder) => {
            setOrder(newOrder);
        };
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        
        return (
            <>
            <Table
                columns={columns}
                data={slicedata}
                loading={loadingData}
                loadingDataLength={5}
                onColumnReorder={handleOnColumnReorder}
                columnReorder
                showFilters
                onSort={handleSort}
                preferences={{
                    defaultOrder: columns.map((c) => c.idPress),
                    order,
                    sortBy: {
                        id: 'limitInitial',
                        type: 'ascending',
                        id: orderBy,
                        type: orderType,
                    }
                }}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems: filteredData.length,
                }}
            />
            </>
        );
    }
    
    const [ShowModalLC,setShowModalLC]=useState(false);
    const handleSelecAudience2 = (name) => (event) => {
        setlowdate(event.value);
    };
    const handleClearAudience = (name) => (event) => {
        setlowdate();
    };
    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: 'css-la566w-padding-Button',
            cancelButton: 'css-k95t6a-padding-Button'
        },
        buttonsStyling: false
    })
    const samemonthlow=()=>{
        let exists = datalow.some((x) => moment(x.monthyear).format("MMM/DD/YYYY") == moment(dateSelected).format("MMM/DD/YYYY"));
        if (exists==true){
        swalWithBootstrapButtons.fire({
            title: "Warning",
            html: "Exist data from the same period, if you continue the previous data will be delete",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText:'Return',
            }).then((result) => {
            if (result.isConfirmed) {
                setShowModalLC(true);
            }
            })
        }else{
            setShowModalLC(true);
        }
    }
    const closemodal=()=>{
        setShowModalLC(false);
    }
    const allgood=()=>{
        fetchData();
        setShowModalLC(false);
    }
    const showmodalagain=()=>{
        setShowModalLC(true)
    }

    return (<>
        <Row>
            <Col style={{
                    marginTop: "5px",
                    marginBottom:"5px"
            }}>
                <Button
                    leadingIcon={<IconPlus />}
                    onClick={() => {samemonthlow()}}
                >{t("addNew")} Files</Button>
            </Col>
            <Col>
                <Select
                    options={selectlow}
                    id="select-usage"
                    label="Select"
                    value={[lowdate]}
                    onClear={handleClearAudience()}
                    onChange={handleSelecAudience2()}
                />
            </Col>
            
        </Row>
        <Row>
            <Col>
                <TableCoverage/>
            </Col>
        </Row>
        <LowCoverageUpload onShowModal={ShowModalLC} confirmationFunction={allgood} onCloseModal={closemodal} showmodalagin={showmodalagain} />
    </>);
}

export default FrameCoverageRender;
